import { Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { DisponibilidadPlanificacion } from 'npm-modelado-catering';
import { DisponibilidadService, RequerimientoCateringService } from 'npm-servicios-catering';
import { Constantes } from '../../../compartido/constantes/constantes';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-disponibilidad-planificacion-normal-listar',
  templateUrl: './disponibilidad-planificacion-normal-listar.component.html',
  styleUrls: ['./disponibilidad-planificacion-normal-listar.component.css']
})
export class DisponibilidadPlanificacionNormalListarComponent extends LoadingPage implements OnInit {

  
  lstFechasDisponiblesPlanificacion: DisponibilidadPlanificacion[];
  selectedDisponibilidad: DisponibilidadPlanificacion;
  busy: Subscription;
  existe:boolean;
  existeRelacionRequerimiento: boolean=false;
  constructor(  private  disponibilidadService: DisponibilidadService,
                private confirmationService: ConfirmationService,
                private router: Router, private routeParams: ActivatedRoute,
                private requerimientosCateringService: RequerimientoCateringService,
                @Inject(LOCALE_ID) private locale: string
                ) { 
    super(true);
  }
  
  ngOnInit() {
    this.cargarEnviroments();
    this.listar();
  }

  agregarClick(){
    this.router.navigate(['/configuracion/disponibilidad-planificacion-normal-crear'])
  }

  async editarClick(){
    if(this.selectedDisponibilidad){
      await this.buscarRequerimientosCateringPorDisponibilidad();
      if (this.selectedDisponibilidad && this.selectedDisponibilidad.idDisponibilidadPlanificacion) {      
          this.enviarEditar();
      } else {
        this.mostrarMensajeInfo(this._noObjetoGrillaEditar);
      }
    }else{
      this.mostrarMensajeInfo(this._debeSeleccinarRegistro);
    }
      
  }

  async eliminarClick(){
 
    if(this.selectedDisponibilidad){
      await this.buscarRequerimientosCateringPorDisponibilidad();
      this.confirmarEliminar();
    }else{
      this.mostrarMensajeInfo(this._debeSeleccinarRegistro);
    }
    
    
  }

  confirmarEliminar(){
    if (this.selectedDisponibilidad && this.selectedDisponibilidad.idDisponibilidadPlanificacion) {
      
      if(!this.existeRelacionRequerimiento){
            this.confirmationService.confirm({
                key: 'autorizacion',
                header: this._tituloEliminarDisponibilidad,
                message: this._indicacionesEliminar+"\t"+' ¿Está seguro que desea eliminar el registro seleccionado?',
                accept: () => {
                  
                this.eliminarDisponibilidad();
                }
            })
      }else{
        this.mostrarMensajeInfo(this._mensajeEliminarDisponibilidadCuandoExistePlanificacion)
      } 
		}else {
			this.mostrarMensajeInfo(this._validacionSeleccionResgistro);
		}
  }

  actualizarEstado(estado: string){  
    
    if(!this.existeRelacionRequerimiento){
     
      this.disponibilidadService.modificar(this.selectedDisponibilidad).then(responseCambiarEstado=>{
        if(responseCambiarEstado){
          this.clearData();
          this.listar();
          this.mostrarMensajeInfo(this._objetoActualizarExito);
        }
      }).catch(error => this.mostrarMensajeError(error));
    }else{
      this.mostrarMensajeInfo(this._mensajeDesactivarDisponibilidadCuandoExistePlanificacion)
    }
    
  }

  buscar(){
    return new Promise(resolve =>{
     this.disponibilidadService.buscar(new Date(this.selectedDisponibilidad.fechaFin)).then(resultBusqueda=>{
       if(resultBusqueda==true){
          this.existe=true;
         resolve();
       }else{
         this.existe= false
         resolve();
       }
    }).catch(error => this.mostrarMensajeError(error));
    });
     
   }

  cargarEnviroments(){
    this.disponibilidadService.set_constantes(Constantes); 
    this.requerimientosCateringService.set_constantes(Constantes);
  }

  clearData(){
    this.selectedDisponibilidad=null;
  }

 eliminarDisponibilidad(){
   
      this.disponibilidadService.eliminarFechaDisponibilidad(this.selectedDisponibilidad.idDisponibilidadPlanificacion).then(responseEliminar =>{
        if(responseEliminar){
            this.clearData();
            this.listar();
            this.mostrarMensajeInfo(this._objetoEliminarExito);
  
        }
      }).catch(error => this.mostrarMensajeError(error));
   
  }
    
  enviarEditar(){
    this.router.navigate(['/configuracion/disponibilidad-planificacion-normal-crear/'],
    {queryParams :{id : this.selectedDisponibilidad.idDisponibilidadPlanificacion, existePlanificacion:this.existeRelacionRequerimiento }});
  }
 
  listar(){
    this.busy=this.disponibilidadService.buscarTodosDisponibilidadPlanificacionNormal(Constantes.TIPO_DISPONIBILIDAD_NORMAL).then(response=>{
      if(response){
        this.lstFechasDisponiblesPlanificacion= response;
      }
    }).catch(error => this.mostrarMensajeError(error));
  }

  buscarRequerimientosCateringPorDisponibilidad(){
    return new Promise(resolve =>{
      this.requerimientosCateringService.buscarExisteRequerimientosCateringPorIdDisponibilidad(this.selectedDisponibilidad.idDisponibilidadPlanificacion).then( responseDisponibilidad =>{  
            this.existeRelacionRequerimiento=responseDisponibilidad;
            resolve(); 
      });
    });
  }
}

